import React from "react";

import { updateConfig } from "../../config/config";
import {
  productTypeAccessory,
  productTypePackage,
  productTypeTire,
  productTypeWheel,
} from "../../constants/productTypes";
import { en } from "../../i18n/translations/en";
import { fr } from "../../i18n/translations/fr";
import { HeaderAddons } from "./HeaderAddons";
import { MazdaHomePage } from "./HomePage";
import { MazdaLogo } from "./MazdaLogo";
import { NationalDescriptor } from "./NationalDescriptor";
import "./theme.css";

Object.assign(en.translation.cart, {
  contactDealer: "Contact Retailer",
  contactDealerForPricing: "Contact Retailer for Pricing",
});

Object.assign(fr.translation.cart, {
  contactDealer: "Contactez le concessionnaire",
  contactDealerForPricing: "Contactez le concessionnaire pour les prix",
});

Object.assign(en.translation.searchResults, {
  contactDealer: "Contact Retailer",
});

Object.assign(fr.translation.searchResults, {
  contactDealer: "Contactez le concessionnaire",
});

Object.assign(en.translation.national, {
  contactDealerForPricing: "Contact Retailer for Pricing",
  dealer: "Retailer",
  selectDealerForPricing: "Select Retailer for Pricing",
  selectDealership: "Select Retailer",
});

Object.assign(fr.translation.national, {
  contactDealerForPricing: "Contactez le concessionnaire pour les prix",
  dealer: "Concessionnaire",
  selectDealerForPricing: "Sélectionnez un concessionnaire pour les prix",
  selectDealership: "Sélectionner un concessionnaire",
});

updateConfig({
  HeaderAddons: () => <HeaderAddons />,
  LandingPageContent: () => <MazdaHomePage />,
  Logo: () => <MazdaLogo className="h-10 md:h-16" />,
  NationalDescriptor: () => <NationalDescriptor />,
  brandName: "Mazda",
  forceBreakDealerName: true,
  googleMapsMarkerSrc: "/static/img/mazda_v2/google_maps_marker.svg",
  landingPageImage: {
    [productTypeAccessory]: "/static/blocks/landing-accessories.png",
    [productTypePackage]: "/static/blocks/landing-packages.png",
    [productTypeTire]: "/static/blocks/landing-tires.png",
    [productTypeWheel]: "/static/blocks/landing-wheels.png",
  },
  productHeroBackground: "/static/img/mazda_v2/product-page-bg.jpg",
  themeClass: "mazda-theme",
});
